import { defineStore } from "pinia";
import services from "./services";
import { UploadUserFile } from "element-plus";
import { FaseEstado, useFasesStore } from "./FaseStore";
import { EstadosTareas } from "./TareasStore";
import Helper from "@/common/Helper";
export interface Proyecto {
  IdProyecto: number;
  Descripcion: string;
  FechaServicio: string;
  Lideres?: string;
  Foto?: string;
  LoteMixto: boolean;
  LoteMixtoComponentes?: string;
  Fase?: string;
  EstimacionComercial?: number;
  Clientes?: string;
  Creado: string;
  CreadoPor: string;
  Equipo: string;
  Subnivel?: string;
  Completado: boolean;
  Duracion: number;
  Iniciado: boolean;
  KeyEquipo: string;
  TareasVencidas: number;
  TareasProximasVencer: number;
  Comentario?: string;
  Unidad: string;
  Division?: string;
}
export interface ProyectoExtend extends Proyecto {
  [key: string]: any;
}
export const useProyectosStore = defineStore("ProyectosStore", {
  // convert to a function
  state: () => ({
    Proyectos: [] as Proyecto[] | undefined,
    ProyectoSelected: {} as Proyecto,
    // ProyectoReferenciasMateriales: {} as ProyectoReferenciasMateriales
  }),
  getters: {
    GetById(state) {
      return (id: number) =>
        state.Proyectos?.find((p: Proyecto) => p.IdProyecto === id);
    },
  },
  actions: {
    async GetProyectos() {
      this.Proyectos = [];
      await services.ProyectoService.getAll()
        .then((result: { data: Proyecto[] }) => {
          this.Proyectos = result.data;
        })
        .catch((error: Error) => {
          console.error("Error al obtener los proyectos:", error);
        });
    },

    async GetProyectoById(idProyecto: number) {
      try {
        const result = await services.ProyectoService.getById(idProyecto);
        this.ProyectoSelected = result.data;
      } catch (error) {
        console.error("Error al obtener el proyecto " + idProyecto, error);
      }
    },
    async AddProyecto(data: Proyecto, image: UploadUserFile) {
      const FaseStore = useFasesStore();
      try {
        if (data.Foto) {
          const imgUrl = await services.StorageService.uploadImage(
            image,
            data.Descripcion + "-" + image.name
          );
          data.Foto = imgUrl;
        }

        const faseEstados: FaseEstado[] = [];
        if (FaseStore.Fases) {
          FaseStore.Fases.forEach((fase) => {
            faseEstados.push({
              Fase: fase.Id,
              Estado: EstadosTareas.ProyectoNoIniciado,
            });
          });

          const jsonFases = {
            Proyecto: faseEstados,
            PAs: [], // vacío por defecto
          };

          data.Fase = JSON.stringify(jsonFases);
        }
        data.Duracion = 0;
        const result = await services.ProyectoService.add(data);
        this.ProyectoSelected = result.data;
        console.log("Proyecto añadido correctamente", result);
        try {
          const { removeSpecialCharacters } = Helper();
          const folderProject = await services.AzureService.getGraphFolderSP(
            removeSpecialCharacters(result.data.Descripcion)
          );
          if (!folderProject) {
            services.AzureService.createFolderSP(
              removeSpecialCharacters(result.data.Descripcion)
            );
            console.log("Carpeta de proyecto creada");
          }
        } catch (error) {
          console.error("No se ha podido crear la carpeta del proyecto", error);
        }
        return result;
      } catch (error) {
        console.error("Error al añadir el proyecto:", error);
        return null;
      }
    },
    async UpdateProyecto(data: Proyecto, image: UploadUserFile) {
      if (
        data.Foto &&
        image.url &&
        (data.Foto?.indexOf("blob:") > -1 || data.Foto !== image.url)
      ) {
        const imgUrl = await services.StorageService.uploadImage(
          image,
          data.Descripcion + "-" + image.name
        );
        data.Foto = imgUrl;
      }

      const result = await services.ProyectoService.update(data);
      this.ProyectoSelected = result.data;
      console.log("Proyecto actualizado correctamente", result);
    },
    async DeleteProyecto(idProyecto: number) {
      await services.ProyectoService.delete(idProyecto)
        .then(() => {
          console.log("Proyecto eliminada correctamente");
        })
        .catch((error: Error) => {
          console.error("Error al eliminar la fase:", error);
        });
    },
  },
});
